module.exports = __webpack_public_path__ + "prod/1.42.2/img/hybrid-cloud-two.3494d7fc.png";